import React, { Suspense } from "react";

import App from "./App";
import "./i18n";
import { ThemeProvider } from "styled-components/macro";
import GlobalStyle from "./styles/global";
import { theme } from "./styles/theme";
import { LoaderCustom } from "components/Loader";
import { createRoot } from "react-dom/client";
import { initAmplify } from "./config/amplify";
import { initSentry } from "./config/sentry";
import GlobalErrorHandler from "./components/GlobalErrorHandler";

initAmplify();
initSentry();

const container = document.getElementById("root");
const root = createRoot(container!);

console.log("Calendly URls", {
  REACT_APP_CALENDLY_MEETING_URL: process.env.REACT_APP_CALENDLY_MEETING_URL,
  REACT_APP_CALENDLY_MEETING_URL_GB:
    process.env.REACT_APP_CALENDLY_MEETING_URL_GB
});

root.render(
  <React.StrictMode>
    <GlobalErrorHandler>
      <Suspense
        fallback={<LoaderCustom size={5} color={theme.colors.bgBody} text="" />}
      >
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Suspense>
      <GlobalStyle />
    </GlobalErrorHandler>
  </React.StrictMode>
);
